export class RulesModel {   
    public axCoinEnabled:boolean;   
    public isStudentVenture:boolean = false;
    public hasStudentVenture:boolean = false;
    public isCoachAccount:boolean = false;
}